import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalViewQuery, {
	type GoalViewQuery as GoalViewQueryType,
} from '../components/__generated__/GoalViewQuery.graphql';

export const goalViewResource: RouteResource<
	PreloadedQuery<GoalViewQueryType, Record<string, unknown>>
> = createRelayResource<GoalViewQueryType>({
	getQuery: (routerContext) => {
		return {
			query: GoalViewQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				goalUpdateDraftsEnabled: fg('townsquare-ai-updates-drafts-on-agg'),
				connectedUpdatesEnabled: fg('goals_connected_updates'),
			},
		};
	},
});
